import React from "react";
import { ModalProps, Modal, Button } from "@blacknut/react-sdk";
import styles from "./styles.module.scss";

interface HeaderElementModalProps extends ModalProps {
  title: string;
  description: string;
  URL?: string;
  headerElement?: JSX.Element;
}

export const HeaderElementModal = (props: HeaderElementModalProps) => {
  const {
    title,
    description,
    headerElement,
    positiveButtonText,
    onPressPositive,
    onPressNegative,
    negativeButtonText,
  } = props;
  return (
    <Modal
      testID="modal"
      className={styles.content}
      {...props}
      title={undefined}
      addButtons={false}
    >
      {headerElement}
      <div className={styles.message}>
        <div>
          <div className={styles.title}>{title}</div>
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>

        <div className={styles.btnBar}>
          <Button
            variant="primary"
            key="ok"
            className={styles.subscribe}
            onClick={onPressPositive}
          >
            {positiveButtonText}
          </Button>

          {onPressNegative && (
            <Button
              variant="secondary"
              key="cancel"
              className={styles.cancel}
              onClick={onPressNegative}
            >
              {negativeButtonText}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};
